/*
 *
 *  #region Copyright (c), Crompton Greaves Consumer Electricals Ltd.
 *  Crompton R&D IoT Department Proprietary Software
 *
 *  This file is part of Crompton Smart Home SDK
 *  Copyright (c) 2023 Crompton Greaves Consumer Electricals Ltd. All rights reserved.
 *  Contact: CROMPTON DEVELOPER SUPPORT <iot.platform@crompton.co.in>
 *
 *  This software, including documentation, is protected by copyright by
 *  Crompton Greaves Consumer Electricals Ltd. All rights are reserved. Copying, including reproducing, storing,
 *  adapting or translating, any or all of this material requires the prior written consent of
 *  Crompton Greaves Consumer Electricals Ltd. This material also contains confidential information which should not
 *  be disclosed to others without the prior written consent of Crompton Greaves Consumer Electricals Ltd.
 *
 *  Filename :
 *  * Created on: <Date>
 *  Author    :
 *  * #endregion
 * /
 *
 */


import React, { useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {useUserAuth} from "./UserAuthContext";

const SessionTimeoutProvider = ({ children, timeout = 24 * 60 * 60 * 1000 }) => {
    const navigate = useNavigate();
    const timerId = useRef(null);
    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();


    const resetTimer = useCallback(() => {
        if (timerId.current) clearTimeout(timerId.current);

        timerId.current = setTimeout(() => {
            // Clear session (e.g., remove token)
            //localStorage.removeItem("token");
            alert("Session expired due to inactivity.");
            //navigate("/"); // Redirect to login
            handleLogOut()
        }, timeout);
    }, [navigate, timeout]);

    const activityEvents = ["click", "mousemove", "keydown", "scroll", "touchstart"];

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    useEffect(() => {
        resetTimer(); // Start on load

        // Reset timer on user activity
        const handleActivity = () => resetTimer();

        activityEvents.forEach(event =>
            window.addEventListener(event, handleActivity)
        );

        return () => {
            activityEvents.forEach(event =>
                window.removeEventListener(event, handleActivity)
            );
            if (timerId.current) clearTimeout(timerId.current);
        };
    }, [resetTimer]);

    return <>{children}</>;
};

export default SessionTimeoutProvider;
